<template>
  <h2>כרטיס אשראי עודכן, תודה</h2>
</template>

<script>
import axios from "../axios";

export default {
  data: function(){
    return {
      name: "pelecard_callback"
    }
  },
  methods: {

    getOrderDetails() { //kobi

      let data = {
        PelecardTransactionId: this.$route.query.PelecardTransactionId
      };

      axios.post(`hova/getOrderTransaction`, data)
        .then((res) => {
          console.log(res);


        }).catch((err) => {
        console.error(err);
      }).finally(() => {
        //  this.appendData()
      })

    }
  },
  beforeMount(){
    this.getOrderDetails()
  }
}

</script>

<style scoped>

</style>
